var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temArquivos
    ? _c(
        "div",
        _vm._b(
          { staticClass: "arquivo-gerado ia-block-card" },
          "div",
          _vm.MOLDURA_DO_THREAD,
          false
        ),
        [
          _c(
            "button",
            {
              staticClass:
                "ia-block-card__cabecalho ia-block-card__cabecalho--fita ia-block-card__cabecalho--clicavel",
              attrs: {
                type: "button",
                "aria-expanded": String(_vm.aberto),
                "aria-label": _vm.ARQUIVO_DO_TURNO.ARIA_LISTA,
                "data-test": "arquivo-gerado-cabecalho"
              },
              on: { click: _vm.alternar }
            },
            [
              _c("icon-svg", {
                staticClass: "ia-block-card__icone",
                attrs: {
                  name: "document-text",
                  size: 14,
                  color: "var(--primary)"
                }
              }),
              _c("span", { staticClass: "ia-block-card__titulo" }, [
                _vm._v(_vm._s(_vm.ARQUIVO_DO_TURNO.TITULO))
              ]),
              _c("span", { staticClass: "ia-block-card__meta" }, [
                _vm._v(_vm._s(_vm.resumo))
              ]),
              _c("icon-svg", {
                staticClass: "ia-block-seta",
                class: _vm.classeSeta,
                attrs: {
                  name: "arrow-down-new-ux",
                  size: 14,
                  color: "var(--neutral-700)"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.aberto,
                  expression: "aberto"
                }
              ],
              staticClass: "arquivo-gerado__corpo"
            },
            [
              _vm._l(_vm.itens, function(item) {
                return _c(
                  "div",
                  {
                    key: item.chave,
                    staticClass: "arquivo-gerado__item",
                    attrs: { "data-test": "arquivo-gerado-item" }
                  },
                  [
                    _c("icon-svg", {
                      attrs: {
                        name: item.icone,
                        size: 14,
                        color: "var(--neutral-700)"
                      }
                    }),
                    _c(
                      "span",
                      { staticClass: "arquivo-gerado__nome ia-texto-auxiliar" },
                      [_vm._v(_vm._s(item.nome))]
                    ),
                    item.legenda
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "arquivo-gerado__legenda ia-texto-auxiliar"
                          },
                          [_vm._v(" " + _vm._s(item.legenda) + " ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              _c(
                "p",
                { staticClass: "arquivo-gerado__nota ia-texto-auxiliar" },
                [_vm._v(_vm._s(_vm.ARQUIVO_DO_TURNO.SEM_DOWNLOAD_AQUI))]
              )
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }